import { AttackRange, DamageType, ItemRarity, Weapon } from 'game/core'
import { ItemUI } from 'game/extended/uis/item_uis'

import image from './goblin_momma_club.png'

export const goblin_momma_club: ItemUI<Weapon> = {
    image,
    label: 'Giant Club',
    value: 200,
    item: {
        key: 'goblin_momma_club',
        type: 'weapon',
        rarity: ItemRarity.Legendary,
        stats: {
            strength: 100,
            health: 100
        },
        two_handed: true,
        category: 'club',
        damageType: DamageType.Melee,
        range: AttackRange.Melee,
        energy: 5,
        damage: 20
    }
}
